import * as types from 'constants/ActionTypes';
import { OVERBOOKED_CATEGORY } from 'utils/passengers';

/**
 * Resets the seat map to its initial state.
 * @returns {Object} An action object to reset the seat map.
 */
export function resetSeatBus() {
  return { type: types.RESET_SEAT_TRIPS };
}
/**
 * Sets the seat configuration for a bus trip.
 * @param {string} way - The direction of the trip (e.g., 'outbound', 'return').
 * @param {Object} trip - The trip object containing bus and diagram type.
 * @param {string} tripSlug - A unique identifier for the trip.
 * @returns {Object} An action object with type, layout, diagram type, and trip slug.
 */
export function setSeatsBus(way, trip, tripSlug) {
  const { bus, diagramType } = trip;
  return {
    way,
    layout: bus,
    diagramType,
    type: types.SET_SEAT_MAP,
    tripSlug,
  };
}

/**
 * Sets the seat configuration error for a bus trip.
 * @param {Object} params - The trip IDs.
 * @param {Object} params.tripId - The trip ID.
 * @param {string} [params.pricingVariant] - Pricing context the failed request asked for.
 * @returns {Object} An action object with type and trip IDs.
 */
export function setSeatsBusError({ tripId, pricingVariant }) {
  return {
    type: types.SET_SEAT_MAP_ERROR,
    tripId,
    ...(pricingVariant && { pricingVariant }),
  };
}

/**
 * Selects overbooking passengers for a specified trip.
 * @param {string} tripSlug - A unique identifier for the trip.
 * @param {number} passengerCount - The number of passengers to create as oversold seats.
 * @param {string} way - The direction of the trip (e.g., 'departs', 'returns').
 * @returns {Object} An action object with type, trip slug, passengers, and way.
 */
export function selectOverbookingPassengers(tripSlug, passengerCount, way) {
  // Convert passenger count to selectedSeats format
  const overbookingSeats = [];
  for (let i = 0; i < passengerCount; i += 1) {
    overbookingSeats.push({
      category: OVERBOOKED_CATEGORY,
      number: null,
      adjacentSeats: null,
    });
  }

  return {
    type: types.SELECT_SEATS_TRIPS,
    tripSlug,
    seats: overbookingSeats,
    way,
  };
}
